import Item from '../TaskDrawer/Item';
import styles from './actionItem.module.css';
import { Box } from '@chakra-ui/react';

function ActionItem({ task, onActionItemClick }) {
  return (
    <Box className={styles.container} p={6} rounded="xl">
      <Box className={styles.link} onClick={onActionItemClick}>
        {task?.task_title}
      </Box>
      <Item
        task={{
          status: task?.status,
          priority: task?.priority,
          dueDate: task?.due_on || 'No due date',
          taskType: task?.task_type || 'Summary',
          assignedToId: task?.assigned_to_id,
          location: task?.location_label,
        }}
        assignmentEditable={false}
      />
    </Box>
  );
}

export default ActionItem;
